import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SummarizeInsightsButton from 'components/buttons/SummarizeInsightsButton';
import styles from './answer-message-footer.scss'; // Reusing existing footer styles

const MultiStepMessageFooter = ({ answerId, isLlmDataAccessAllowed }) => {
  // The button itself handles the isLlmDataAccessAllowed logic (renders null if not allowed)
  // So, we only render the footer structure if the button would be visible.
  if (!isLlmDataAccessAllowed) {
    return null;
  }

  return (
    <div className={styles.buttonsContainer}>
      <ul className={styles.list}>
        <li className={styles.item}>
          <SummarizeInsightsButton
            answerId={answerId}
            isLlmDataAccessAllowed={isLlmDataAccessAllowed}
            summaryDetailsKey="summarize-insights"
          />
        </li>
      </ul>
    </div>
  );
};

MultiStepMessageFooter.propTypes = {
  answerId: PropTypes.string.isRequired,
  questionId: PropTypes.string.isRequired,
  isLlmDataAccessAllowed: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired
};

export default withTranslation('veezoo')(MultiStepMessageFooter);
